import React from 'react'
import { editableDateRecordToString } from '@utils/editable_date'
import FormattedTime from '@components/FormattedTime'
import { InternalTimelineEditorValue } from '../TimelineEditor'

type DateDisplayProps = {
  value: InternalTimelineEditorValue
}

const DateDisplay: React.FC<DateDisplayProps> = ({ value }) => {
  const { s, e } = value
  const startDate = s ? editableDateRecordToString(s) : null
  const endDate = e ? editableDateRecordToString(e) : null

  let content: React.ReactNode

  if (startDate === null && endDate === null) {
    content = 'Select date(s)'
  } else if (endDate === null) {
    content = <FormattedTime dateTime={startDate} />
  } else if (startDate === null) {
    content = <FormattedTime dateTime={endDate} />
  } else {
    content = (
      <>
        <FormattedTime dateTime={startDate} /> - <FormattedTime dateTime={endDate} />
      </>
    )
  }

  return <span>{content}</span>
}

export default DateDisplay
